import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import { push } from "react-router-redux";
import store from "./store";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL + "/graphql/",
  credentials: "include"
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Token token=${token}` : "",
      "Access-Control-Allow-Origin": process.env.DOMAIN
    }
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      console.log("error message is ->", message);
      if (message === "Unauthorized") {
        store.dispatch(push("/"));
      }
    });
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache()
});

export default client;



// WEBPACK FOOTER //
// ./src/apollo-client.js